module.exports = __webpack_public_path__ + "public/img/bahasa-inggris-untuk-adminsitrasi-dan-legalitas-perkantoran-belakang.e0d684c5.png";